/**
 * Collab app base URL for magic-link handoff (matches beatly-web-app getExternalServiceUrl('collab')).
 */
export function collabBaseUrlForHostname(hostname: string): string {
  if (
    hostname.includes('staging.beatly.com') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1'
  ) {
    return 'https://collab.staging.beatly.com';
  }
  return 'https://collab.beatly.com';
}

export function getCollabBaseUrl(): string {
  if (typeof window === 'undefined') {
    return 'https://collab.beatly.com';
  }
  return collabBaseUrlForHostname(window.location.hostname);
}

/**
 * Full navigation to Collab with session JWT, mirroring beatly-web-app checkToken influencer branch.
 */
export function redirectToCollabWithSession(pathAndSearch: string, sessionJwt: string): void {
  const base = getCollabBaseUrl();
  const sep = pathAndSearch.includes('?') ? '&' : '?';
  window.location.href = `${base}${pathAndSearch}${sep}jwt=${encodeURIComponent(sessionJwt)}`;
}
